import { render, staticRenderFns } from "./PopupAddLegalDocument.vue?vue&type=template&id=6270aa74&scoped=true&"
import script from "./PopupAddLegalDocument.vue?vue&type=script&lang=js&"
export * from "./PopupAddLegalDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6270aa74",
  null
  
)

export default component.exports